import { render, staticRenderFns } from "./OnboardingSuccessPage.vue?vue&type=template&id=53f77db8"
import script from "./OnboardingSuccessPage.vue?vue&type=script&lang=ts"
export * from "./OnboardingSuccessPage.vue?vue&type=script&lang=ts"
import style0 from "./OnboardingSuccessPage.vue?vue&type=style&index=0&id=53f77db8&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports